<app-popover class="add-cab-form" (closeCallback)="cancelCallback()" size="small" titleText="Add New Cab">
    <div popover-content>
       <form [formGroup]="formDetails" *ngIf="formDetails">
          <div class="form-control">
             <label class="form-label">Driver Name</label>
             <app-text-input class="form-input" [formControl]="formDetails.get('driverName')" ></app-text-input>
          </div>
          <div class="form-control">
             <label class="form-label">Driver Mobile Number</label>
             <app-text-input type="number" class="form-input" [formControl]="formDetails.get('driverContact')" ></app-text-input>
          </div>
          <div class="form-control" *ngIf="!isUserVendor">
              <label class="form-label">Vendor</label>
              <app-select
               class="form-input"
               [options]="vendors"
               [getCustomOptionValue]="getVendorValue"
               [getCustomOptionLabel]="getVendorLabel"
               [formControl]="formDetails.get('vendorId')" >
              </app-select>
           </div>
          <div class="form-control">
             <label class="form-label">Cab Registration Number</label>
             <div class="form-input">
              <app-text-input [formControl]="formDetails.get('registrationNo')" ></app-text-input>
              <div *ngIf="validateRegNo" class="helper-text">Please enter value without space, hyphens and special characters</div>
            </div>
          </div>
          <div class="form-control">
             <label class="form-label">Cab Make</label>
             <app-text-input class="form-input" [formControl]="formDetails.get('cabModel')" ></app-text-input>
          </div>
          <div class="form-control">
             <label class="form-label">Comment</label>
             <span class="optional">(optional)</span>
             <app-text-input class="form-input" multiline="true" [formControl]="formDetails.get('comment')" ></app-text-input>
          </div>
       </form>
    </div>
    <div popover-actions>
       <app-button (clickCallback)="cancelCallback()" class="mr-10" type="plainText" text="Cancel"></app-button>
       <app-button (clickCallback)="onSubmitClick()" type="primaryFilled" text="Submit"></app-button>
    </div>
 </app-popover>
 <app-dialog *ngIf="addCabError" titleText="Error" (approveCallback)="hideAddCabError()"  type="alert" [buttonText]="['Ok']">
    {{addCabError}}
 </app-dialog>
 <app-loader *ngIf="isLoading"></app-loader>

